import React from 'react';
import { Pressable, Platform, StyleSheet } from 'react-native';
import Icon from '@/components/Icon';

export default function ChecklistDismissButton({ onPress, colors }) {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel="Dismiss Get Started"
      accessibilityHint="Hide this panel for your account on this device."
      style={({ hovered, pressed }) => [
        styles.button,
        (hovered || pressed) && { backgroundColor: colors.solid_color_tertiary },
      ]}
    >
      <Icon name="xmark" size={12} color={colors.text_color_tertiary} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    width: Platform.OS === 'web' ? 32 : 44,
    height: Platform.OS === 'web' ? 32 : 44,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
});
